import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';

import { isInternalLink } from '../../utils/helpers';
const PageLink = ({ children, to, ...otherProps }) => {
	if (isInternalLink(to)) {
		return (
			<Link to={to} {...otherProps}>
				{children}
			</Link>
		);
	}

	return (
		<a href={to} target="_blank" rel="noopener noreferrer" {...otherProps}>
			{children}
		</a>
	);
};

PageLink.propTypes = {
	children: PropTypes.node,
	to: PropTypes.string,
};

PageLink.defaultProps = {
	children: null,
	to: '',
};

export default PageLink;
